import { isProduction } from '../environment';
import { PropertyAPI as RealPropertyAPI } from './property-api';
import { PropertyAPI as MockPropertyAPI } from './mock-property-api';

export default isProduction() ? RealPropertyAPI : MockPropertyAPI;